import type { FetchFn } from '@zenstackhq/client-helpers/fetch';
import { getAuthToken, clearAuthToken } from '../auth/AuthContext';

/** Custom fetch passed to QuerySettingsProvider so every ZenStack hook call
 *  carries the bearer token — and so an expired/invalid session (HTTP 401) drops
 *  the stale token and sends the user to /login instead of letting a loader spin
 *  forever on a dead token. */
export const authFetch: FetchFn = async (input, init) => {
  const token = getAuthToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(input, { ...init, headers });

  // Only act when we actually sent a token: a 401 then means it's expired/invalid
  // (not a public endpoint or a wrong-password login, which carry no token).
  if (res.status === 401 && token) {
    clearAuthToken();
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.assign('/login');
    }
  }
  return res;
};
